import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import SmartForm from 'components/SmartForm';
import { getAllWarehouses, saveWarehouse } from 'rdx/warehouses';
import { getPointsOfSale } from 'rdx/pointsOfSale';
import { getCompanyDetails } from 'rdx/company';
import { fetchAddresses, getAllAddresses } from 'rdx/addresses';
import { CTAButtons } from 'components';

import { locationSchema } from './schemas';

import './locations.scss';

function Locations() {
  const [addressOptions, setOptions] = useState({
    locationAddress: [],
  });
  const dispatch = useDispatch();
  const mainFormRef = React.useRef(null);
  const warehouses = useSelector(getAllWarehouses);
  const registers = useSelector(getPointsOfSale);
  const companyDetails = useSelector(getCompanyDetails);
  const allAddresses = useSelector(getAllAddresses);
  const addressesObj = {};

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchAddresses({ ownerID: companyDetails.id }));
  }, [companyDetails, dispatch]);

  useEffect(() => {
    allAddresses.forEach((address) => {
      addressesObj[
        address.addressID
      ] = `${address.addressID}. ${address.postalCode} ${address.state}, ${address.country}`;
    });
    setOptions({
      locationAddress: [
        'Choose location address',
        ...Object.values(addressesObj),
      ],
    });
    // eslint-disable-next-line
  }, [allAddresses]);

  const locationSubmit = () => {
    const { values } = mainFormRef.current;
    if (values.locationName !== '') {
      dispatch(
        saveWarehouse({
          name: values.locationName,
          addressID: values.locationAddress.slice(0, 1),
        }),
      );
    }
  };
  const buttons = {
    close: { onClick: () => navigate('/setup/company') },
    next: {
      onClick: () => navigate('/setup/general'),
    },
  };

  return (
    <div className="d-flex flex-fill flex-column">
      <SmartForm
        grid
        ref={mainFormRef}
        fields={locationSchema}
        handleSubmit={locationSubmit}
        options={addressOptions}
        className="locations-page"
      >
        <div className="add-location-cta" onClick={locationSubmit}>
          <Button size="sm">ADD LOCATION</Button>
        </div>

        <div className="tables-container">
          <h3>All Locations</h3>
          <Table striped bordered hover className="stores-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              {warehouses.map((record) => {
                console.log({ record });
                return (
                  <tr key={record.warehouseID}>
                    <td>{record.name}</td>
                    <td>{record.address}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <h3>All Registers</h3>
          <Table striped bordered hover className="registers-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {registers.map((record) => (
                <tr key={record.warehouseID}>
                  <td>{record.name}</td>
                  <td>{record.warehouseName}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </SmartForm>
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default Locations;
